import Vue from 'vue'
import Vuex from 'vuex'
import authentication from './modules/authentication'
import surveys from './modules/surveys'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
        authentication,
        surveys
    },
    strict: debug,
    plugins: [createPersistedState()]
})
